export default __webpack_public_path__ + "static/media/Emojis11.5e4db1e9.png";